export default "__VITE_ASSET__BUmN8$rD__"